import React, { useEffect, useState } from "react";
import CompTicketsModal from "./CompTicketsModal";
import "../styles/mobileShortcuts.css";

const MobileShortcutsButton = ({ team, csrfToken, canCompTickets = true, conductorEnabled = false }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showCompTicketsModal, setShowCompTicketsModal] = useState(false);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("conductorOrbInsetChanged"));
    return () => window.dispatchEvent(new CustomEvent("conductorOrbInsetChanged"));
  }, []);

  const handleMenuToggle = () => setMenuOpen((prev) => !prev);

  const handleCompTickets = () => {
    setMenuOpen(false);
    setShowCompTicketsModal(true);
  };

  const launchConductor = () => {
    setMenuOpen(false);
    window.dispatchEvent(new CustomEvent("openConductor", { detail: { source: "mobile_shortcut" } }));
  };

  const launchVoiceMode = () => {
    setMenuOpen(false);
    window.dispatchEvent(new CustomEvent("openConductor", { detail: { voice: true, source: "mobile_shortcut" } }));
  };

  return (
    <>
      {menuOpen && (
        <div
          className="quick-actions-backdrop"
          onClick={() => setMenuOpen(false)}
        />
      )}

      <div className={`quick-actions-sheet ${menuOpen ? "quick-actions-sheet--open" : ""}`}>
        <div className="quick-actions-handle" />
        <div className="quick-actions-header">
          <h3 className="quick-actions-title">Quick Actions</h3>
          <p className="quick-actions-subtitle">Shortcuts for common tasks</p>
        </div>
        <div className="quick-actions-list">
          {conductorEnabled && (
            <>
              <button className="quick-actions-item" onClick={launchVoiceMode}>
                <span className="quick-actions-icon quick-actions-icon--red">
                  <i className="fas fa-microphone" />
                </span>
                <span className="quick-actions-item-text">
                  <span className="quick-actions-item-title">Voice Mode</span>
                  <span className="quick-actions-item-desc">Talk to Conductor hands-free</span>
                </span>
              </button>
              <button className="quick-actions-item" onClick={launchConductor}>
                <span className="quick-actions-icon quick-actions-icon--red">
                  <i className="fas fa-sparkles" />
                </span>
                <span className="quick-actions-item-text">
                  <span className="quick-actions-item-title">Launch Conductor</span>
                  <span className="quick-actions-item-desc">Open the Conductor AI assistant</span>
                </span>
              </button>
            </>
          )}
          {canCompTickets && (
            <button className="quick-actions-item" onClick={handleCompTickets}>
              <span className="quick-actions-icon quick-actions-icon--red">
                <i className="fas fa-ticket-alt" />
              </span>
              <span className="quick-actions-item-text">
                <span className="quick-actions-item-title">Comp Tickets</span>
                <span className="quick-actions-item-desc">Issue comp tickets for an upcoming event</span>
              </span>
            </button>
          )}
        </div>
      </div>

      <button className="quick-actions-trigger" onClick={handleMenuToggle} data-conductor-orb-inset>
        <i className="fas fa-plus" />
        Quick Actions
      </button>

      <CompTicketsModal
        isOpen={showCompTicketsModal}
        onClose={() => setShowCompTicketsModal(false)}
        team={team}
        csrfToken={csrfToken}
      />
    </>
  );
};

export default MobileShortcutsButton;
